var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marker",class:'marker-' + _vm.type,on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.markers[_vm.type],"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }